import OrganizationRateCardIndexPage from "./OrganizationRateCardIndexPage";
export default OrganizationRateCardIndexPage;
